import {Component, React, observer} from '$src/handy'

@observer
export default class SplashUnlessBootstrapped extends Component<{children: React.ReactNode}, {}> {
  render() {
    // Splash screen for now is empty. If needed, we can do a custom splash screen too
    return this.store.general.bootstrapped ? this.props.children : ''
  }
}



// WEBPACK FOOTER //
// ./src/bootstrap/routing/SplashUnlessBootstrapped.tsx